// Module
var code = "<svg fill=none viewBox=\"0 0 24 24\" stroke=currentColor> <path stroke-linecap=round stroke-linejoin=round stroke-width=2 d=\"M14 5l7 7m0 0l-7 7m7-7H3\"/> </svg> ";
// Exports
module.exports = code;